module.exports = __webpack_public_path__ + "img/hc_pro_seven_1.f2f9e083.jpg";